const __WEBPACK_NAMESPACE_OBJECT__ = require("highcharts-react-official");